import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for handling the animation of the landing hero text wrapper
 */
export default class LandingHero extends MessageBus {
  /**
   * Constructor function of the LandingHero class.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {HTMLElement} element - The container element
     */
    this.element = element;

    this.init();
  }

  /**
   * Initializes the view by setting up the scroll event listener
   * @returns {LandingHero} A reference to the current instance of the class
   * @chainable
   */
  init() {
    window.addEventListener(EVENTS.LOAD, () => {
      const textWrapper = this.element.querySelector(
        `.${CLASS_NAMES.LANDING_HERO_CONTENT}`
      );

      if (textWrapper) {
        textWrapper.classList.add(CLASS_NAMES.ANIMATE);
      }
    });

    return this;
  }
}
